import { render } from "./System-Children.vue?vue&type=template&id=010a7dfd&scoped=true"
import script from "./System-Children.vue?vue&type=script&lang=js"
export * from "./System-Children.vue?vue&type=script&lang=js"

import "./System-Children.vue?vue&type=style&index=0&id=010a7dfd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010a7dfd"]])

export default __exports__